<template>
    <div v-if="currentPage">
        <div class="multistep-wizard-form-step-page"  v-for="(page, index) in pages"
             :key="index"
             :id="'page'+(index+1)"
             v-show="currentPage === index + 1">
            <slot :name="'page-'+(index+1)" />
        </div>
    </div>

</template>

<script>
export default {
    name: "design-2021-apprentice-multistep-form-wizard-page-component",
    props: {
        pages: {
            type: Array,
            required: true,
        },

        currentPage: {
            type: Number,
            required: true,
        }
    },

    data() {
        return {

        }
    },
}
</script>

<style scoped>

</style>
